/* tslint:disable */
/* eslint-disable */
/**
 * Zamna Ready To Fly API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 2.18
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * Option to choose for `pick-from-list-question`
 * @export
 * @interface PaxCheckOption
 */
export interface PaxCheckOption {
    /**
     * Option id
     * @type {string}
     * @memberof PaxCheckOption
     */
    id: string;
    /**
     * Option title (localised)
     * @type {string}
     * @memberof PaxCheckOption
     */
    title: string;
}

/**
 * Check if a given object implements the PaxCheckOption interface.
 */
export function instanceOfPaxCheckOption(value: object): value is PaxCheckOption {
    if (!('id' in value) || value['id'] === undefined) return false;
    if (!('title' in value) || value['title'] === undefined) return false;
    return true;
}

export function PaxCheckOptionFromJSON(json: any): PaxCheckOption {
    return PaxCheckOptionFromJSONTyped(json, false);
}

export function PaxCheckOptionFromJSONTyped(json: any, ignoreDiscriminator: boolean): PaxCheckOption {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'],
        'title': json['title'],
    };
}

export function PaxCheckOptionToJSON(json: any): PaxCheckOption {
    return PaxCheckOptionToJSONTyped(json, false);
}

export function PaxCheckOptionToJSONTyped(value?: PaxCheckOption | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'id': value['id'],
        'title': value['title'],
    };
}

